// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-jxfzcx-scjtJxfzcx-index-main_right_content-26Bds","table":"components-tjcx-jxfzcx-scjtJxfzcx-index-table-1XoNZ"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/jxfzcx/scjtJxfzcx/index.css
// module id = 2308
// module chunks = 0